import * as React from "react";

function IcProductCarRentalFill(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcProductCarRentalFill"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 7H5C3.89543 7 3 6.10457 3 5V4C3 2.89543 3.89543 2 5 2H8.5C9.32843 2 10 2.67157 10 3.5H19.5C20.0523 3.5 20.5 3.94772 20.5 4.5C20.5 5.05228 20.0523 5.5 19.5 5.5H10C10 6.32843 9.32843 7 8.5 7ZM4 20V21C4 21.8284 4.67157 22.5 5.5 22.5C6.32843 22.5 7 21.8284 7 21V20H17V21C17 21.8284 17.6716 22.5 18.5 22.5C19.3284 22.5 20 21.8284 20 21V20C20.6129 19.6936 21 19.0672 21 18.382V15C21 14.4477 20.5523 14 20 14L20.6412 13.3588C20.8555 13.1445 20.9086 12.8172 20.7731 12.5461C20.6164 12.2328 20.2531 12.0823 19.9207 12.1931L19 12.5L18.6961 11.1323C18.2894 9.30213 16.6661 8 14.7913 8H9.20869C7.33389 8 5.71064 9.30213 5.30394 11.1323L5 12.5L4.07927 12.1931C3.74689 12.0823 3.38362 12.2328 3.22693 12.5461C3.09141 12.8172 3.14453 13.1445 3.35881 13.3588L4 14C3.44772 14 3 14.4477 3 15V18.382C3 19.0672 3.38713 19.6936 4 20ZM6 5.5V3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V5.5C5 5.77614 5.22386 6 5.5 6C5.77614 6 6 5.77614 6 5.5ZM7.12331 14H16.8767C17.1966 14 17.4342 13.7038 17.3648 13.3915L17.022 11.8492C16.717 10.4766 15.4996 9.5 14.0935 9.5H9.90651C8.50042 9.5 7.28298 10.4766 6.97795 11.8492L6.63521 13.3915C6.56582 13.7038 6.80343 14 7.12331 14ZM6.5 18H8.5C9.05228 18 9.5 17.5523 9.5 17C9.5 16.4477 9.05228 16 8.5 16H6.5C5.94772 16 5.5 16.4477 5.5 17C5.5 17.5523 5.94772 18 6.5 18ZM17.5 18H15.5C14.9477 18 14.5 17.5523 14.5 17C14.5 16.4477 14.9477 16 15.5 16H17.5C18.0523 16 18.5 16.4477 18.5 17C18.5 17.5523 18.0523 18 17.5 18Z"
        fill="#087E8B"
      />
    </svg>
  );
}

export default IcProductCarRentalFill;
